import { Injectable } from '@angular/core';
import { Product } from "src/app/shared/models/product";
import { Subject, BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DataService {
  cartQtySubject = new Subject<number>();
  cartPriceSubject = new Subject<number>();
  cartVatPriceSubject = new Subject<number>();
  cartItemsSubject = new Subject<[]>();
  productsSubject = new Subject<[]>();
  vatTotalSubject = new Subject<number>();


  

  private productList = new BehaviorSubject([]);
  currentData = this.productList.asObservable();


  private merchant = new BehaviorSubject("");
  merchantName = this.merchant.asObservable();



  private merchantData = new BehaviorSubject({});
  merchantDetails = this.merchantData.asObservable();


  private merchantConfigData = new BehaviorSubject({});
  merchantConfig = this.merchantConfigData.asObservable();

  private cartItemData = new BehaviorSubject([]);
  cartItems = this.cartItemData.asObservable();
  

  constructor() { }

  changeData(data: []) {
    this.productList.next(data);
  }

  setMerchant(name:string){
    this.merchant.next(name);
  }

  setMerchantDetails(merchant:{}){
    this.merchantData.next(merchant);
  }

  setMerchantConfig(merchant:{}){
    this.merchantConfigData.next(merchant);
  }
  setCartItems(cart:[]){
    this.cartItemData.next(cart);
  }


}
